import React, { useState } from 'react';
import ProductVariation from './ProductVariation';

function ProductRow({ product, index, currentPage, onEditClick }) {
  const [selectedVariation, setSelectedVariation] = useState({
    variation_id: '',
    variation_name: '',
  });
console.log(selectedVariation)
  const handleVariationChange = (e) => {
    const selectedIndex = e.target.selectedIndex - 1; // Adjust for the first disabled option
    setSelectedVariation({
      variation_id: e.target.value,
      variation_name: product.variations_name[selectedIndex],
    });
  };

  // Determine text color based on publish status
  const textStyle = {
    color: product.publish_status === 'publish' ? '#007BFF' : '#FF6347', // Active: Blue, Inactive: Tomato
  };

  return (
    <tr>
      <td>{index + 1 + (currentPage - 1) * 10}</td>

      <td>
        <a href={product.url} target="_blank" rel="noopener noreferrer">
          {product.name}
        </a>
      </td>
      {/* <td>{product.stock}</td>
      <td>{product.price}</td> */}
      <td style={textStyle}>{product.publish_status}</td>
      <td>
        <ProductVariation product={product} onEditClick={onEditClick} handleVariationChange = {handleVariationChange} />
      </td>

      {/* <td>
        <button
          className="edit-button"
          onClick={() => onEditClick({ product, ...selectedVariation })}
        >
          Edit
        </button>
      </td> */}
    </tr>
  );
}

export default ProductRow;
